export default {
  name: `rotate_screen`,
  cta: `请转动你的屏幕`,
};
